export const LOGIN = "LOGIN/REQUEST";
export const LOGIN_FAILED = "LOGIN/REQUEST_FAILED";
